import { PrizmLanguageKit } from '../../interfaces';

export const PRIZM_RUSSIAN_LANGUAGE_KIT: PrizmLanguageKit = {
  cancel: `Отменить`,
  done: `Готово`,
  more: `Еще`,
  otherDate: `Другая дата`,
  showAll: `Показать все`,
  hide: `Скрыть`,
  mobileCalendarTexts: [`Выберите день`, `Выберите период`],
  range: [`от`, `до`],
  countTexts: [`Плюс`, `Минус`],
  time: {
    'HH:MM': `ЧЧ:ММ`,
    'HH:MM:SS': `ЧЧ:ММ:СС`,
    'HH:MM:SS.MSS': `ЧЧ:ММ:СС.МСС`,
  },
  dateTexts: {
    DMY: `дд.мм.гггг`,
    MDY: `мм.дд.гггг`,
    YMD: `гггг.мм.дд`,
  },
  digitalInformationUnits: [`Б`, `КБ`, `МБ`],
  passwordTexts: [`Показать пароль`, `Скрыть пароль`],
  copyTexts: [`Копировать`, `Скопировано`],
  shortCalendarMonths: [
    `Янв`,
    `Фев`,
    `Март`,
    `Апр`,
    `Май`,
    `Июнь`,
    `Июль`,
    `Авг`,
    `Сен`,
    `Окт`,
    `Нояб`,
    `Дек`,
  ],
  pagination: [`Предыдущая страница`, `Следующая страница`],
  fileTexts: {
    loadingError: `Ошибка загрузки`,
    preview: `Предварительный просмотр`,
    remove: `Удалить`,
  },
  inputFileTexts: {
    defaultLabelSingle: `или перетащите\u00A0его\u00A0сюда`,
    defaultLabelMultiple: `или перетащите\u00A0их\u00A0сюда`,
    defaultLinkSingle: `Выберите файл`,
    defaultLinkMultiple: `Выберите файлы`,
    maxSizeRejectionReason: `Файл превышает объем `,
    formatRejectionReason: `Неверный формат файла`,
    drop: `Поместите файл сюда`,
    dropMultiple: `Поместите файлы сюда`,
  },
  search: `Поиск`,
};
